import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

const JobDetailsTabs = ({ baseSlug, jobId, primaryColor }: any) => {
  const location = useLocation();
  const currentPath = location.pathname;
  const [lighterShade, setLighterShade] = useState<string | null>(null);
  const tabs = [
    {
      name: 'Overview',
      path: `/${baseSlug}/${jobId}`,
      isActive: currentPath === `/${baseSlug}/${jobId}`
    },
    {
      name: 'Application',
      path: `/${baseSlug}/${jobId}/apply`,
      isActive: currentPath === `/${baseSlug}/${jobId}/apply`
    }
  ];

    useEffect(() => {
      if (primaryColor) {
        document.documentElement.style.setProperty('--component-primary-color', primaryColor);
        const lighter = calculateLighterShade(primaryColor, 0.26);
        const mainBgShare =  calculateLighterShade(primaryColor, 0.93);
        setLighterShade(lighter);
        document.documentElement.style.setProperty('--hover-primary-color', lighter);
        document.documentElement.style.setProperty('--main-bg-color', mainBgShare);
      }
    }, [primaryColor]);
  
    // Helper function to calculate lighter shade for hover state
    const calculateLighterShade = (hex: any, percent: any) => {
      // Remove the hash if it exists
      hex = hex.replace('#', '');
  
      // Convert hex to RGB
      let r = parseInt(hex.substring(0, 2), 16);
      let g = parseInt(hex.substring(2, 4), 16);
      let b = parseInt(hex.substring(4, 6), 16);
  
      // Calculate lighter values (adding the percentage)
      r = Math.min(255, Math.round(r + (255 - r) * percent));
      g = Math.min(255, Math.round(g + (255 - g) * percent));
      b = Math.min(255, Math.round(b + (255 - b) * percent));
  
      // Convert back to hex
      const toHex = (n: any) => {
        const hex = n.toString(16);
        return hex.length === 1 ? '0' + hex : hex;
      };
  
      return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
    };

  return (
    <div className="border-b border-gray-200">
      <nav className="flex space-x-4 md:space-x-6 lg:space-x-8" aria-label="Tabs">
        {tabs.map((tab) => (
          <Link
            key={tab.name}
            to={tab.path}
            // className={`
            //   inline-flex items-center px-1 py-4 text-sm font-medium border-b-2 mb-[-2px]
            //   ${tab.isActive 
            //     ? 'border-indigo-500 text-indigo-600'
            //     : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
            //   }
            // `}
            className={`
              inline-flex items-center px-1 py-2 md:py-4 lg:py-4 text-sm font-medium border-b-2 mb-[-2px]
              ${tab.isActive
                ? 'tab-active' // Apply active tab styles
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300' // Apply inactive tab styles
              }
            `}
            aria-current={tab.isActive ? 'page' : undefined}
          >
            {tab.name}
          </Link>
        ))}
      </nav>
    </div>
  );
};

export default JobDetailsTabs;